module.exports = __webpack_public_path__ + "media/images/sites/health/metatag-948cb1e5ab257022a34aba45687b736d.jpg";